import React from 'react';
import { ReactComponent as ReactLogo } from '../../../../src/assets/svg/profile-options-icon.svg';

function ProfileOptionsIcon(props: {
    className?: string;
    height?: string | number;
    width?: string | number;
    fill?: string;
}) {
    return (
        <ReactLogo
            className={props.className}
            width='36px'
            height='36px'
            fill={props.fill}
        />
    );
}

export default ProfileOptionsIcon;
